
<div class="points__card-container">
  <app-transport-list-card 
    [style.top.px]="topPositionTransportList"
    [transportList]="transportList()"
    [maxHeight]="marginTop"
    [isOverflow]="isTransportListOverflow()"
    [pointTitle]="point().title"
    [previousPointTitle]="previousPointTitle()"
    [indexCard]="indexCard()"
    [status]="status()" 
    [isEndLocationCard]="isLocationCard()"
  />
  
  <article 
    #cardRef
    [class]="'points__card' + ' ' + status()"
    [attr.data-is-location-card]="isLocationCard()"
    (click)="handleClickPoint(point().id)"
  >
  
    <app-header 
      [indexCard]="indexCard()"
      [title]="point().title"
      [img]="point().img"
      [defaultImg]="getDefaultImgFileName(indexCard())"
      [durationMinutes]="point().duration"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
    
    <app-main
      [title]="point().title"
      [startDate]="getStartDate()"
      [durationMinutes]="point().duration"
      [isLocationCard]="isLocationCard()"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
  </article>
</div>
